import React from 'react'
import PropTypes from 'prop-types'

export default function Button({
  arrow,
  background,
  backgroundHover,
  color,
  colorHover,
  label,
  openInNewTab,
  url,
}) {
  const buttonStyles = {
    '--button-background': background,
    '--button-background-hover': backgroundHover,
    '--button-color': color,
    '--button-color-hover': colorHover,
  }

  return (
    <a
      aria-label="Learn more"
      className={`landingLinkBtn ${arrow}`}
      href={url}
      rel={openInNewTab ? 'noreferrer noopener' : ''}
      style={buttonStyles}
      target={openInNewTab ? '_blank' : '_self'}
    >
      {label}
    </a>
  )
}

Button.propTypes = {
  arrow: PropTypes.string.isRequired,
  background: PropTypes.string.isRequired,
  backgroundHover: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  colorHover: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  openInNewTab: PropTypes.bool.isRequired,
  url: PropTypes.string.isRequired,
}
